import { IBranchesList } from 'core/model/interfaces/distributors/branches.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { IDistributorsState } from '../../types';

export const fetchAllBranches = createAppAsyncThunk<IBranchesList>(
  `${SLICE_NAMESPACE}/fetchAllBranches`,
  async (_, store) => {
    try {
      const state = store.getState();

      const { userSession, distributors } = state;

      const { branchesList } = distributors;

      const { query, pagination } = branchesList;

      const { currentPage } = pagination;

      const { subject = '' } = userSession ?? {};

      return await apiService.branches.getBranches({
        page: currentPage,
        query: query || undefined,
        subject: subject || '',
        itemsPerPage: 10,
      });
    } catch (error) {
      notificationService.global.error(handleErrorMessage(error, 'Falló al obtener las sucursales.'));

      throw error;
    }
  },
);

export const fetchBranchesReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(fetchAllBranches.pending, state => {
      state.branchesList.loading.default = true;
    })
    .addCase(fetchAllBranches.rejected, state => {
      state.branchesList.branches = [];
      state.branchesList.loading.default = false;
    })
    .addCase(fetchAllBranches.fulfilled, (state, action) => {
      state.branchesList.branches = action.payload.branches;
      state.branchesList.pagination = action.payload.pagination;
      state.branchesList.loading.default = false;
    });
